import type { PublisherFollowersHistoryPoint } from "../types";

export async function getPublisherFollowers(
  clanid: number,
  range: string,
  resolution: "raw" | "hourly" | "daily" | "weekly" | "monthly" = "monthly",
  bust?: number,
  init?: RequestInit
): Promise<PublisherFollowersHistoryPoint[]> {
  const searchParams = new URLSearchParams({
    range,
    resolution,
  });

  if (bust != null) {
    searchParams.set("bust", String(bust));
  }

  const response = await fetch(
    `/api/publisher/${clanid}/followers?${searchParams.toString()}`,
    {
      cache: "no-store",
      ...init,
    }
  );

  const payload = (await response.json()) as
    | {
        error?: string;
      }
    | PublisherFollowersHistoryPoint[];

  if (!response.ok) {
    const errorPayload = payload as { error?: string };
    throw new Error(
      errorPayload?.error ?? "Failed to fetch publisher followers history"
    );
  }

  // Response can be either an array directly or an object with points
  if (Array.isArray(payload)) {
    return payload;
  }

  return [];
}
